import { Component } from '@verndale/core';
import clamp from 'clamp-js';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $teaserText: this.el._$$(
        '.press-release-row__single-card-description-text'
      )
    };
    this.teaserMaxLines = 3;

    this.init();
  } //setupDefaults

  init() {
    this.clampTeaser();
  } //init

  clampTeaser() {
    const { $teaserText } = this.dom;

    for (const $teaser of $teaserText) {
      clamp($teaser, { clamp: this.teaserMaxLines });
    }
  } //clampTeaser
}

export default Module;
